(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const faqItems = document.querySelectorAll('.faq-item');
        faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            const answer = item.querySelector('.faq-answer');
            question.addEventListener('click', function() {
                faqItems.forEach(i => {
                    if (i !== item) {
                    i.classList.remove('active');
                    }
                });
                item.classList.toggle('active');
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }
  });

  document.addEventListener("shopify:section:load", () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }

    function isInViewport(elem) {
      const rect = elem.getBoundingClientRect();
      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    const stickyBar = document.querySelector('.PDP__stk__mainwrapper');
    const header = document.querySelector('.section-header');
    const headerHeight = header ? header.clientHeight : 0;
    const addToCartElements = document.querySelectorAll('[js-scroll-identity]');
    const footerSections = document.querySelectorAll('.shopify-section-group-footer-group');

    function shouldHideSticky() {
      for (const el of [...addToCartElements, ...footerSections]) {
        if (el && isInViewport(el)) return true;
      }
      return false;
    }

    function handleStickyScroll() {
      const scrollY = window.scrollY;
      const triggerElement = document.querySelector('[js-scroll-identity]');
      if (!triggerElement || !stickyBar) return;
      const triggerOffset = triggerElement.offsetTop;
      if (scrollY > triggerOffset) {
        if (shouldHideSticky()) {
          stickyBar.classList.remove('active');
        } else {
          stickyBar.classList.add('active');
        }
      } else {
        stickyBar.classList.remove('active');
      }
    }
    window.addEventListener('scroll', handleStickyScroll, { passive: true });

    document.querySelector('.PDP__stk__actionbtn')?.querySelector('.product-form__submit')?.addEventListener('click',(tg)=>{
      tg.preventDefault();
      document.querySelector('.product-form__buttons')?.querySelector('.product-form__submit')?.click();
    })

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smilab-pdp-buy"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const stage = root.querySelector('.sp-gallery__stage');
    const slides = Array.from(stage.children);
    const thumbs = Array.from(root.querySelectorAll('.sp-gallery__thumbs a'));
    const previous = root.querySelector('.sp-gallery__prev');
    const next = root.querySelector('.sp-gallery__next');
    let active = 0;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    function update() {
      active = Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / stage.clientWidth)));
      previous.disabled = active === 0;
      next.disabled = active === slides.length - 1;
      thumbs.forEach((thumb, i) => { if (i === active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
      root.querySelector('[data-sp-caption]').textContent = thumbs[active]?.dataset.spCaption || '';
      root.querySelector('[data-sp-count]').textContent = `${active + 1} / ${slides.length}`;
      root.querySelector('.sp-gallery__zoom').href = slides[active].dataset.spFull;
    }
    function go(index) {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      stage.scrollTo({left:target * stage.clientWidth, behavior:reduced.matches ? 'auto' : 'smooth'});
    }
    thumbs.forEach((thumb,i) => thumb.addEventListener('click',e => {e.preventDefault();go(i);}));
    previous.addEventListener('click',() => go(active - 1));
    next.addEventListener('click',() => go(active + 1));
    stage.addEventListener('keydown',e => {if(e.key === 'ArrowLeft' || e.key === 'ArrowRight'){e.preventDefault();go(active + (e.key === 'ArrowRight' ? 1 : -1));}});
    let ticking = false;
    stage.addEventListener('scroll',() => {if(!ticking){ticking=true;requestAnimationFrame(()=>{update();ticking=false;});}},{passive:true});
    const sizeObserver = new ResizeObserver(() => {stage.scrollTo({left:active * stage.clientWidth,behavior:'instant'});update();});
    sizeObserver.observe(stage);
    update();
    const main = root.querySelector('[data-sp-main]');
    const headerCart = document.querySelector('header a[href="/cart"], .sl-header a[href="/cart"]');
    const openHeaderCart = e => {
      const drawer=document.querySelector('cart-drawer');
      if(!drawer) return;
      e.preventDefault();
      if(typeof drawer.open==='function') drawer.open(headerCart);
      else {drawer.classList.add('animate','active');document.body.classList.add('overflow-hidden');drawer.querySelector('.drawer__inner')?.focus();}
    };
    if(headerCart) headerCart.addEventListener('click',openHeaderCart);
    const sticky = root.querySelector('.sp-sticky');
    const stickyObserver = new IntersectionObserver(entries => {const entry=entries[0];sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;},{threshold:0});
    stickyObserver.observe(main);
    const form = root.querySelector('#smilab-pdp-form');
    const status = root.querySelector('[data-sp-status]');
    let busy = false;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (busy || main.disabled) return;
      busy = true;
      const trigger = e.submitter || main;
      const buttons = Array.from(document.querySelectorAll('[form="smilab-pdp-form"], #smilab-pdp-form button'));
      buttons.forEach(b => {b.disabled=true;b.setAttribute('aria-busy','true');});
      status.hidden=true; status.classList.remove('is-error');
      let added=false;
      try {
        const drawer = document.querySelector('cart-drawer');
        const data = new FormData(form);
        if(drawer && typeof drawer.getSectionsToRender === 'function'){
          data.append('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));
          data.append('sections_url',window.location.pathname);
          drawer.setActiveElement(trigger);
        }
        if(typeof window.__markInternalCartCall==='function') window.__markInternalCartCall();
        const response = await fetch(form.action + '.js',{method:'POST',body:data,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
        const result = await response.json();
        if(!response.ok || result.status) throw new Error(result.description || root.dataset.error);
        added=true;status.textContent=root.dataset.added;status.hidden=false;
        if(drawer && result.sections && typeof drawer.renderContents === 'function'){
          drawer.classList.remove('is-empty');drawer.renderContents(result);
        } else {root.querySelector('.sp-buy__cart-link').hidden=false;}
      } catch(error) {
        if(added){root.querySelector('.sp-buy__cart-link').hidden=false;}
        else {status.textContent=error.message || root.dataset.error;status.classList.add('is-error');status.hidden=false;status.scrollIntoView({block:'center',behavior:'smooth'});}
      } finally {busy=false;buttons.forEach(b=>{b.disabled=false;b.removeAttribute('aria-busy');});}
    });
    root.addEventListener('sp:dispose',()=>{sizeObserver.disconnect();stickyObserver.disconnect();if(headerCart)headerCart.removeEventListener('click',openHeaderCart);});
  }
  document.querySelectorAll('[data-sp-buy]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-sp-buy]').forEach(init));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-sp-buy]').forEach(el=>el.dispatchEvent(new Event('sp:dispose'))));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smilab-product"] && !Shopify.designMode) return;
  try {
    
function initSmilabProduct(){document.querySelectorAll('.sl-product').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const stage=root.querySelector('.sl-product__stage');root.querySelectorAll('.sl-product__thumbs a').forEach(a=>a.addEventListener('click',e=>{const photo=root.querySelector(a.getAttribute('href'));if(photo){e.preventDefault();stage.scrollTo({left:photo.offsetLeft-stage.firstElementChild.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}}));const button=root.querySelector('.sl-product__main-button');const sticky=root.querySelector('.sl-sticky');if(button&&sticky){new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0}).observe(button);}});}initSmilabProduct();document.addEventListener('shopify:section:load',initSmilabProduct);

  } catch(e) { console.error(e); }
})();
})();
